import React from "react";

export const Bio = () => {
  return (
    <section
      id="bio"
      className="relative w-full py-24 md:py-32 px-6 md:px-12 lg:px-20 bg-[#050505]"
      data-testid="bio-section"
    >
      <div className="max-w-5xl mx-auto">
        <p className="font-display text-xs tracking-[0.4em] uppercase text-[#FF007F] mb-6">
          // 01 — A zenekarról
        </p>
        <h2 className="font-display font-bold tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl mb-12">
          Bemutatkozás
        </h2>

        <div className="grid md:grid-cols-12 gap-8 md:gap-16">
          <div className="md:col-span-8">
            <p
              className="font-body text-lg md:text-xl text-white/70 leading-relaxed"
              data-testid="bio-text"
            >
              A <span className="text-white">Charge</span> egy cover zenekar igényes
              zenei világgal, főként Charlie dalok feldolgozásával nyújt pozitív
              élményt a hallgatók számára. A zenekar énekese és alapítója sok Charlie
              koncerten vett részt a 2000-es években, mint vokalista. A 2006-ban
              megjelenő <span className="text-white">„Másképp ugyanúgy"</span> című
              Charlie lemezre egy dalszöveget is írt,{" "}
              <span className="text-white">„Száguldás az élet"</span> címmel.
              <br /><br />
              A zenei végzettséggel rendelkező tagok kezdetben számos előadótól
              szólaltattak meg dalokat a koncertjeiken, míg végül eljutottak a
              Charlie Band rock, jazz, blues, soul &amp; funk letisztult, színvonalas
              zenéjéhez. Ettől kezdve <span className="text-[#00E5FF]">(2019)</span>{" "}
              vették fel a{" "}
              <span className="text-white">Charge Charlie Cover Band</span> nevet.
            </p>

            <div className="mt-12 grid grid-cols-2 gap-8 max-w-md">
              <div className="border-l border-[#00E5FF]/40 pl-4">
                <p className="font-display text-3xl font-bold text-[#00E5FF]">5</p>
                <p className="font-body text-xs uppercase tracking-widest text-white/50 mt-1">
                  Tag
                </p>
              </div>
              <div className="border-l border-[#FF007F]/40 pl-4">
                <p className="font-display text-3xl font-bold text-[#FF007F]">100%</p>
                <p className="font-body text-xs uppercase tracking-widest text-white/50 mt-1">
                  Élő hangzás
                </p>
              </div>
            </div>
          </div>

          <div className="md:col-span-4 flex md:justify-end">
            <div className="relative w-full max-w-xs">
              <div className="absolute -inset-1 bg-gradient-to-br from-[#00E5FF] via-[#7000FF] to-[#FF007F] opacity-30 blur-lg" />
              <div className="relative bg-[#0A0A0A] border border-white/10 p-8">
                <p className="font-display text-xs tracking-[0.3em] uppercase text-white/50">
                  Stílus
                </p>
                <p className="font-display text-2xl text-white mt-2">
                  Rock / Jazz / Blues / Soul &amp; Funk
                </p>
                <div className="mt-6 h-px w-12 bg-[#00E5FF]" />
                <p className="font-body text-sm text-white/60 mt-6 leading-relaxed">
                  Koncertek, fesztiválok és rendezvények — ahol valódi energia
                  kell.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Bio;
